// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__switzer_64bbd3', '__switzer_Fallback_64bbd3'"},"className":"__className_64bbd3","variable":"__variable_64bbd3"};